module.exports = __webpack_public_path__ + "media/maps/more-green-3f46ef7b.svg";